import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const BillIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M2.685 1.714a1.505 1.505 0 0 1 1.084-.464h8.462c.412 0 .802.17 1.084.464.282.293.435.684.435 1.086V14a.75.75 0 0 1-1.23.576l-1.386-1.153-1.055 1.097a.75.75 0 0 1-1.081 0L8 13.482l-.998 1.038a.75.75 0 0 1-1.081 0l-1.055-1.097-1.386 1.153A.75.75 0 0 1 2.25 14V2.8c0-.402.153-.793.435-1.086ZM3.77 2.75l-.005.004a.067.067 0 0 0-.016.046v9.6l.693-.577a.75.75 0 0 1 1.02.057l.999 1.038.997-1.038a.75.75 0 0 1 1.082 0l.997 1.038.998-1.038a.75.75 0 0 1 1.02-.057l.694.577V2.8a.068.068 0 0 0-.016-.046l-.005-.004H3.771Z"/>
        <path d="M5.25 5A.75.75 0 0 1 6 4.25h4a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 5ZM5.25 8A.75.75 0 0 1 6 7.25h2a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 8Z"/>
    </svg>
);
BillIcon.displayName = 'BillIcon';
export default BillIcon;
